import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ConnectedTextField from '../../_atomic/ConnectedTextField/ConnectedTextField';
import { currencyValidator } from '../../../utils/helpers';
import mask from './assets/mask';
import './CurrencyFieldPlatforms.scss';

const currencyFieldPlatforms = ({
  label,
  placeholder,
  isRequired,
  name,
  value,
  isFocused,
  status,
  errorText,
  contextProvider,
  disabled,
  changeHandler,
  focusHandler,
  minValue,
  maxValue,
  floatCount,
  disabledView,
  currencySign,
  specifiedValidator,
  allowNegative,
  platform,
}) => {
  const currencyFieldWrapperClasses = classNames({ 'currency-field-wrapper': true, disabled });
  const renderValue = disabled ? '' : value;
  return (
    String(value).length &&
    <div className={currencyFieldWrapperClasses}>
      <ConnectedTextField
        label={label}
        type="text"
        platform={platform}
        placeholder={placeholder}
        isRequired={isRequired}
        value={renderValue}
        isFocused={isFocused}
        status={status}
        errorText={errorText}
        name={name}
        disabled={disabled}
        specifiedValidator={specifiedValidator}
        contextProvider={contextProvider}
        mask={mask}
        disabledView={disabledView}
        minValue={minValue}
        changeHandler={changeHandler}
        focusHandler={focusHandler}
        maxValue={maxValue}
        floatCount={floatCount}
        allowNegative={allowNegative}
      />
      <div className="currency-sign">
        <span>{currencySign}</span>
      </div>
    </div>
  );
};

currencyFieldPlatforms.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  errorText: PropTypes.string,
  status: PropTypes.string.isRequired,
  isFocused: PropTypes.bool,
  contextProvider: PropTypes.string,
  disabled: PropTypes.bool,
  changeHandler: PropTypes.func,
  focusHandler: PropTypes.func,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  floatCount: PropTypes.number,
  currencySign: PropTypes.node,
  disabledView: PropTypes.bool,
  specifiedValidator: PropTypes.func,
  allowNegative: PropTypes.bool,
  platform: PropTypes.string,
};
currencyFieldPlatforms.defaultProps = {
  label: 'Currency',
  placeholder: 'Currency',
  isRequired: false,
  name: '',
  value: '',
  errorText: '',
  isFocused: false,
  disabled: false,
  contextProvider: '',
  changeHandler: null,
  focusHandler: null,
  minValue: -Infinity,
  floatCount: 2,
  maxValue: Infinity,
  disabledView: false,
  currencySign: '$',
  specifiedValidator: currencyValidator,
  allowNegative: false,
  platform: 'None',

};
export default currencyFieldPlatforms;



// WEBPACK FOOTER //
// ./src/components/_molecules/CurrencyFieldPlatforms/CurrencyFieldPlatforms.js